import { Component } from '@angular/core';
import { UserService } from '../../services/user.service';
import { CompanyStatus } from '../../../models/common';

@Component({
    templateUrl: './inactive-account.component.html',
    styleUrls: ['./inactive-account.component.scss']
})
export class InactiveAccountComponent {
    public readonly billingPageLink = '/account-settings/billing';

    public supportMode: boolean;
    public billingMode: boolean;
    public adminMode: boolean;

    constructor(private _userService: UserService) {
        this.billingMode = _userService.isAgency;
        this.supportMode = _userService.isAdvertiser;
        this.adminMode = _userService.isAdmin || _userService.isAnalyst;
    }

    get isSsoUser(): boolean {
        return this._userService.isSsoUser;
    }

    get isFutureAccount() {
        const currentAdvertiser = this._userService.getCurrentAdvertiser();
        return currentAdvertiser && currentAdvertiser.status === CompanyStatus.FUTURE;
    }

    get startDate() {
        const currentAdvertiser = this._userService.getCurrentAdvertiser();
        return currentAdvertiser && currentAdvertiser.startDate;
    }

    public contactSupport(): void {
        this._userService.contactSupport();
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/inactive-account/inactive-account.component.ts